import { Container, Flex, Image, Text, Title } from "@mantine/core";
import Login from "../Layout/Login";

export default function Landing() {
  return (
    <>
      <Container fluid maw={"75%"} h={"100vh"}>
        <Flex
          direction={"column"}
          align={"center"}
          justify={"center"}
          content={"center"}
          w={"100%"}
          h={"100%"}
        >
          <Flex
            direction={"row"}
            align={"center"}
            justify={"center"}
            content={"center"}
            ml={"sm"}
            w={"100%"}
          >
            <Image
              src="./logoSolo.png"
              alt="logo"
              maw="40px"
              w="40px"
              h="40px"
            />
            <svg
              width="60"
              height="20"
              viewBox="0 0 35 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.276931 9.70767H2.13406C2.17092 10.8771 3.08106 11.7871 4.41791 11.7871C5.86676 11.7871 6.83218 10.8586 6.83218 9.42843C6.83218 8.09177 5.81147 7.10806 4.38105 7.10806H2.76492V5.51059L5.92205 2.35392V2.24194H0.554792V0.441772H8.41146V2.22493L5.17919 5.3816V5.49358C7.24047 5.66084 8.8566 7.25689 8.8566 9.41142C8.8566 11.566 7.24047 13.6638 4.43634 13.6638C1.63221 13.6638 0.275513 11.5461 0.275513 9.70767H0.276931Z"
                fill={"black"}
              />
              <path
                d="M10.8822 0.442688H15.525C18.1803 0.442688 19.89 2.07701 19.89 4.43566C19.89 6.29252 18.7389 7.68588 17.3084 8.20467L20.2614 13.4407H17.996L15.3407 8.50092H12.8896V13.4407H10.8836V0.442688H10.8822ZM15.4329 6.75603C16.808 6.75603 17.8287 5.97643 17.8287 4.43424C17.8287 3.17129 16.9739 2.16915 15.3592 2.16915H12.8896V6.75603H15.4343H15.4329Z"
                fill={"black"}
              />
              <path
                d="M32.2296 0.442871L28.0063 7.91994L23.7831 0.442871H21.7275V13.4409H23.6584V4.45427H23.7704L27.2082 10.4005H28.0063H28.8045L32.2423 4.45427H32.3543V13.4409H34.2866V0.442871H32.2296Z"
                fill={"black"}
              />
            </svg>
          </Flex>
          <Title
            align="center"
            mt={"36px"}
            mb={"10px"}
            w={"120%"}
            sx={(theme) => ({
              fontFamily: `Soehne, ${theme.fontFamily}`,
              fontWeight: 900,
            })}
          >
            Telegram Folder Message
          </Title>
          <Text color={"dimmed"} mb={"40px"}>
            First, log in to your Telegram account.
          </Text>
          <Login />
        </Flex>
      </Container>
    </>
  );
}
